import moment from 'moment-timezone';

import { getVisitTypeLabel, VisitType } from 'common-src/models/PatientOncehubBooking';

import { AthenaRawStatus, ScheduledCallTabs } from './constants';

export const canceledFilter = (booking) => {
  if (booking.isAthenaAppointment) {
    return booking._fields?.statusRaw === AthenaRawStatus.CANCELED;
  }
  return booking?.status === 'canceled';
};

export const getScheduledCallTabs = (oncehubBookings, timeZone) => {
  const upcoming =
    oncehubBookings?.filter(
      (b) =>
        !moment()
          .tz(timeZone)
          .isAfter(
            moment(b.isAthenaAppointment ? b._fields?.scheduledAt : b.scheduledAt).tz(timeZone),
          ) && !canceledFilter(b),
    )?.length || 0;
  const past =
    oncehubBookings?.filter(
      (b) =>
        moment()
          .tz(timeZone)
          .isAfter(
            moment(b.isAthenaAppointment ? b._fields?.scheduledAt : b.scheduledAt).tz(timeZone),
          ) && !canceledFilter(b),
    )?.length || 0;
  const canceled = oncehubBookings?.filter((b) => canceledFilter(b))?.length || 0;

  return {
    UPCOMING: {
      text: ScheduledCallTabs.UPCOMING.text,
      count: upcoming,
    },
    PAST: {
      text: ScheduledCallTabs.PAST.text,
      count: past,
    },
    CANCELED: {
      text: ScheduledCallTabs.CANCELED.text,
      count: canceled,
    },
    ALL: {
      text: ScheduledCallTabs.ALL.text,
      count: upcoming + past + canceled,
    },
  };
};

export const getScheduledCallType = (scheduledCall) => {
  const visitType = scheduledCall?.isAthenaAppointment
    ? scheduledCall?._fields?.visitType
    : scheduledCall?.visitType;
  return getVisitTypeLabel(visitType);
};

export const getScheduledCallTypeOrEventName = (scheduledCall) => {
  const visitTypeLabel = getScheduledCallType(scheduledCall);
  const eventName = scheduledCall?.isAthenaAppointment
    ? scheduledCall?._fields?.eventName
    : scheduledCall?.eventName;

  return visitTypeLabel !== VisitType.Unknown.label ? visitTypeLabel : (eventName ?? '-');
};
